module.exports = __webpack_public_path__ + "img/transaction.5284d350.png";